import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Segment } from 'semantic-ui-react';

import * as cmAPI_Action from 'actions/commons';

class WeekUI extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dayValue: '000000'
    };
  }

  componentWillMount() {
    const { day } = this.props.dayValue;
    this.setState({
      dayValue: day ? day.value : '000000'
    });
  }

  //요일 클릭
  weekClick = (e, isWeek, key) => {
    let spreadDayValue = [...this.state.dayValue],
      value = '',
      numberKey = Number(key);

    e.target.className = isWeek === '0' ? 'ui blue inverted green week active' : 'ui blue inverted green week';

    for (let i = 0 ; i < spreadDayValue.length ; i++) {
      if (i === numberKey) {
        value += isWeek === '0' ? '1' : '0';
      } else {
        value += spreadDayValue[i];
      }
    }
    this.setState({
      dayValue: value
    });

    const { commonFn } = this.props;

    commonFn.changeWeek({
      type: 'week',
      name: 'value',
      value: value
    });
  };

  //각 활성화 요일 UI
  weekIsActive = (day, isWeek, key) => {
    return (
      <Button
        inverted
        id="week-btn"
        className={(isWeek === '1' ? 'week active' : 'week') + (day === '일' ? ' list-day' : '')}
        key={key}
        onClick={(e) => this.weekClick(e, isWeek, key)}
      >
        {day}
      </Button>
    );
  };

  render() {
    const { dayValue } = this.state,
      week = [6];

    if (dayValue) {
      for (var i in dayValue) {
        let weekName = '',
          isWeek = dayValue[i].toString();

        switch (i) {
          case '0':
            weekName = '일';
            week[6] = this.weekIsActive(weekName, isWeek, i);
            break;
          case '1':
            weekName = '월';
            week[0] = this.weekIsActive(weekName, isWeek, i);
            break;
          case '2':
            weekName = '화';
            week[1] = this.weekIsActive(weekName, isWeek, i);
            break;
          case '3':
            weekName = '수';
            week[2] = this.weekIsActive(weekName, isWeek, i);
            break;
          case '4':
            weekName = '목';
            week[3] = this.weekIsActive(weekName, isWeek, i);
            break;
          case '5':
            weekName = '금';
            week[4] = this.weekIsActive(weekName, isWeek, i);
            break;
          case '6':
            weekName = '토';
            week[5] = this.weekIsActive(weekName, isWeek, i);
            break;
          default:
        }
      }
    }

    return <div className="week-form">{week}</div>;
  }
}

WeekUI = connect(
  (state) => ({
    week: state.commons.week
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeWeek: cmAPI_Action.ReduxDataSet
      },
      dispatch
    )
  })
)(WeekUI);

export default WeekUI;
